import { forwardRef, useImperativeHandle, useState, useEffect, useMemo } from 'react';
import { Modal, message } from 'antd';
import styles from './index.module.scss';
import API from '@api/api';

const InvitationRecordModal = forwardRef((props, ref) => {
    const [visible, setVisible] = useState(false);

    useImperativeHandle(ref, () => ({
        open: () => setVisible(true),
        close: () => setVisible(false),
    }));

    const [recordList, setRecordList] = useState([]);

    const hasRecords = useMemo(() => recordList && recordList.length > 0, [recordList]);

    useEffect(() => {
        ladderInvitationList()
    }, [])

    const ladderInvitationList = () => {
        if (!localStorage.getItem('token')) return
        API.ladderInvitationList({
        }).then((res) => {
            if (res.code == 0) {
                setRecordList(res.data)
            }
        })
    }

    return (
        <Modal
            open={visible}
            onCancel={() => setVisible(false)}
            footer={null}
            width={1000}
            centered={false}
            className={styles.invitationRecordModal}
            style={{ top: 245 }}
            zIndex={1003}
        >
            <div className={styles.modalContent}>
                <h2 className={styles.title}>邀请记录</h2>
                {hasRecords ? (
                    <>
                        <div className={styles.tableHeader}>
                            <div className={styles.headerItem}>好友账号</div>
                            <div className={styles.headerItem}>好友注册时间</div>
                            <div className={styles.headerItem}>记录</div>
                            <div className={styles.headerItem}>天梯奖励</div>
                        </div>
                        <div className={styles.tableBody}>
                            {recordList.map((record, index) => (
                                <div key={index} className={styles.tableRow}>
                                    <div className={styles.tableCell}>{record.invitee}</div>
                                    <div className={styles.tableCell}>{record.registerTime}</div>
                                    <div className={styles.tableCell}>{record.title}</div>
                                    <div className={styles.tableCell}>{record.bonus}</div>
                                </div>
                            ))}
                        </div>
                    </>
                ) : (
                    <>
                        <div className={styles.tableHeader}>
                            <div className={styles.headerItem}>好友账号</div>
                            <div className={styles.headerItem}>好友注册时间</div>
                            <div className={styles.headerItem}>记录</div>
                            <div className={styles.headerItem}>天梯奖励</div>
                        </div>
                        <div className={styles.emptyState}>
                            <div className={styles.emptyIcon}></div>
                        </div>
                    </>

                )}
            </div>
        </Modal>
    );
});

export default InvitationRecordModal;
